import { render, staticRenderFns } from "./LetterCreate.vue?vue&type=template&id=7a97cd11&scoped=true&"
import script from "./LetterCreate.vue?vue&type=script&lang=js&"
export * from "./LetterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97cd11",
  null
  
)

export default component.exports